<template>
  <div class="shop-profile-map" :class="{ 'is-big': big }">
    <div v-if="big">
      <div class="top-right corner">
        <span
          class="button is-rounded is-white has-text-grey"
          style="padding: 10px; box-shadow: 1px 1px 3px grey"
          @click="toggleZoom"
        >
          <i class="fa fa-expand" :class="{ 'fa-spin': zooming }" />
        </span>
      </div>
      <div class="top-left corner">
        <span
          class="button is-rounded is-white"
          style="padding: 12px; box-shadow: 1px 1px 3px grey"
          @click="$emit('closeBig')"
          ><i class="fa fa-chevron-left"
        /></span>
      </div>
    </div>
    <div class="bottom-right corner">
      <span class="distance has-text-grey tag is-white" @click="distanceInfo">
        <i class="fa fa-route" style="margin-right: 4px" />
        {{ distancePretty }}
      </span>
    </div>
    <div class="map-wrapper">
      <div :id="mapID" class="map" />
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus.js";
import L from "leaflet";
import geo from "@/geo";

export default {
  name: "ShopProfileMap",
  props: {
    big: Boolean,
    locations: Array,
    business: Object,
    commerce: Object,
  },
  data() {
    return {
      mapID: "shop-profile-map-map",
      map: undefined,
      marker: undefined, // business marker
      userMarker: undefined,
      polygon: undefined, // free delivery polygon
      toggle: false, // zoom toggle
      // rideHint: false,
      popupOpts: { closeButton: false, autoPan: true },
      zooming: false, // debounce
    };
  },
  computed: {
    userCoords() {
      return this.$store.getters.getUserLatLon;
    },
    isNearby() {
      if (!this.userCoords) return false;
      var d = geo.distanceToUserInMeters(this.business, this.userCoords);
      return d < 10 * 1000; // within 10km?
    },
    distancePretty() {
      var d = geo.distanceToUserInMeters(this.business, this.userCoords);
      var drivingDist = Math.round(d * 1.3);
      return geo.prettyDistance(drivingDist, 1000000000);
    },
    freeDeliveryPolygon() {
      if (!this.commerce) return null;
      return this.commerce.data.free_delivery_polygon;
    },
  },
  created() {
    L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";
  },
  mounted() {
    // setTimeout(() => {
    this.initMap();
    // this.updateMarkerLocation(this.business);
    this.init(); // trigger zoom to biz and/or user
    // }, 1000);
    // EventBus.$on("SHOP_PROFILE_MAP", () => {
    //   if (this.business) this.updateMarkerLocation(this.business);
    //   this.init(); // trigger ride hint
    // });
    // this.updateMarkerLocation(this.business);
    // this.init(); // trigger zoom to biz and/or user
  },
  methods: {
    init() {
      // this.rideHint = true;
      // setTimeout(() => (this.rideHint = false), 2500);
      this.drawFreeDeliveryPolygon();
      // if (this.big) this.drawFreeDeliveryPolygon();
      this.toggle = true; // reset for initial zoom
      this.toggleZoom();
      if (this.big) {
        setTimeout(() => this.toggleZoom(), 1000);
      } else {
        // this.map.fitTo([this.marker], { padding: [100, 100] });
      }
      // this.$nextTick(() => this.map.invalidateSize());
    },
    distanceInfo() {
      if (this.zooming) return;
      this.zooming = true;
      setTimeout(() => (this.zooming = false), 1000);
      this.$toast.open("Distance from your current location.");
    },
    drawFreeDeliveryPolygon() {
      if (!this.freeDeliveryPolygon) return;
      var polygon = {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: this.freeDeliveryPolygon,
        },
      };
      this.polygon = L.geoJSON(polygon)
        .addTo(this.map)
        .bindPopup(`Free Delivery Area`, this.popupOpts);
      this.polygon.setStyle({
        fillColor: "yellow",
        fillOpacity: 0.1,
        stroke: 1,
        opacity: 0.3,
        color: "grey",
      });
    },
    // triggerTransportToShop() {
    //   setTimeout(() => this.goToRide(), 700);
    // },
    updateMarkerLocation(b) {
      this.map.invalidateSize(); // redraw map
      this.toggle = false; // reset toggle
      this.setIcon(b);
      this.marker.setLatLng(b); // business already contains coords in necessary format
      var userCoords = this.$store.getters.getUserLatLon;
      if (userCoords) this.userMarker.setLatLng(userCoords);
      this.map.setView(b, 16);
    },
    setBusinessMarkerLocations() {
      var bizIcon = L.AwesomeMarkers.icon({
        icon: "store-alt",
        markerColor: "purple",
      });
      // initially set to random initial location, will update on eventbus
      // this.marker = L.marker(coords, { icon: bizIcon }).addTo(this.map);
      this.marker = L.marker(this.business, { icon: bizIcon }).addTo(this.map);
      this.marker.bindPopup(this.business.name, this.popupOpts); // would need to update this

      // draw more locations if have
      if (this.locations) {
        this.locations.forEach((l) => {
          L.marker(l, { icon: bizIcon }).addTo(this.map).bindPopup("HIIII");
          // .bindPopup(`${l.lat}, ${l.lon}`, this.popupOpts);
        });
      }

      this.map.invalidateSize(); // redraw map
      this.toggle = false; // reset toggle
      this.setIcon(this.business);
      // this.marker.setLatLng(b); // business already contains coords in necessary format
      var userCoords = this.$store.getters.getUserLatLon;
      if (userCoords) this.userMarker.setLatLng(userCoords);
      this.map.setView(this.business, 16);
    },
    toggleZoom() {
      if (this.zooming) return;
      this.zooming = true;
      setTimeout(() => (this.zooming = false), 1000);
      this.updateLocation(); // ask for location in case don't have yet
      var zoomTo = [this.marker]; // zoom to shop by default
      if (this.polygon) zoomTo.push(this.polygon); // or shop+polygon if exists
      if (this.userCoords && !this.toggle) {
        this.userMarker.setLatLng(this.userCoords); // set user marker
        zoomTo = [this.marker, this.userMarker];
      }
      var group = new L.featureGroup(zoomTo);
      this.map.fitBounds(group.getBounds(), { padding: [100, 100] });
      setTimeout(() => {
        if (this.map.getZoom() > 16) this.map.setZoom(16); // zoom out a bit if too close
      }, 1500);
      this.toggle = !this.toggle;
    },
    setIcon(b) {
      var iconOpts = { icon: "store-alt", markerColor: "purple" };
      if (b && b.business_type === "Service") {
        iconOpts = { icon: "tools", markerColor: "green" };
      }
      var icon = L.AwesomeMarkers.icon(iconOpts);
      this.marker.setIcon(icon);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps

      var coords = [13.73114, 100.57529]; // soi 41, just a random location to init

      this.map = L.map(this.mapID, { attributionControl: false });
      this.map.setView(coords, 16); // set zoom level
      this.map.removeControl(this.map.zoomControl);
      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        // minZoom: 10,
        maxZoom: 17,
      }).addTo(this.map);
      this.map.invalidateSize();

      // var opts = { closeButton: false, autoPan: true }; // popup opts
      // draw business marker
      var bizIcon = L.AwesomeMarkers.icon({
        icon: "store-alt",
        markerColor: "purple",
      });
      // initially set to random initial location, will update on eventbus
      // this.marker = L.marker(coords, { icon: bizIcon }).addTo(this.map);
      this.marker = L.marker(this.business, { icon: bizIcon }).addTo(this.map);
      this.marker.bindPopup(this.business.name, this.popupOpts); // would need to update this

      // draw more locations if have
      if (this.locations) {
        this.locations.forEach((l) => {
          var coords = `${l.lat}, ${l.lon}`;
          if (l.name) coords = l.name + "<br>" + coords;
          L.marker(l, { icon: bizIcon })
            .addTo(this.map)
            .bindPopup(coords, this.popupOpts);
        });
      }

      // this.setBusinessMarkerLocations();

      // draw user marker
      var userIcon = L.AwesomeMarkers.icon({
        icon: "street-view",
        markerColor: "blue",
      });
      // initially set to random initial location, will update on eventbus
      this.userMarker = L.marker(coords, { icon: userIcon }).addTo(this.map);
      this.userMarker.bindPopup("Your Location", this.popupOpts);
    },
  },
};
</script>

<style scoped>
.shop-profile-map {
  position: relative;
  height: 100%;
  z-index: 0;
  filter: grayscale(100%);
}
.is-big {
  position: absolute;
  width: 100vw;
  max-width: 700px;
  height: calc(100vh - 200px);
  /* height: 100vh; */
  bottom: 0px !important;
  top: 0;
  z-index: 2;
  filter: grayscale(0);
}
.map-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 0;
}
.map {
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 0;
}
/* #shop-profile-map-map .leaflet-top {
  pointer-events: auto;
}*/
.shadow {
  filter: drop-shadow(1px 1px 2px #333);
}
/* .fade-enter-active, */
.fade-leave-active {
  transition: opacity 1s;
}
/* .fade-enter,  */
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.wiggle:active {
  transform: rotate(350deg);
  -webkit-transform: rotate(350deg);
  -ms-transform: rotate(350deg);
}
.tuktuk {
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.14);
  background-color: rgb(255, 255, 255, 0.95);
  border-radius: 3px;
  padding: 0px 4px;
  display: inline-block;
}
.tuktuk img {
  margin-bottom: -5px;
  height: 35px;
  filter: drop-shadow(0px 0px 0px #333);
}
.distance {
  padding: 5px;
  margin: 2px;
  /* margin: 4px; */
  box-shadow: 0 0 1px grey;
}
.top-right {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.top-left {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.bottom-right {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
}
.bottom-left {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.corner {
  margin: 2px;
}
.is-big .corner {
  margin: 5px;
}
</style>